module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="' +
((__t = (globalClassName)) == null ? '' : __t) +
'">\n    ';
 _.forEach(results,function(result) { ;
__p += '\n    <div>\n        <div class="' +
((__t = (titleClassName)) == null ? '' : __t) +
'">' +
((__t = (result.title)) == null ? '' : __t) +
'</div>\n        ';
 var aData = result.data[0];;
__p += '\n        <table>\n            <tbody>\n                ';
 result.fields.forEach(function(field) {;
__p += '\n                <tr>\n                    <td class="' +
((__t = (labelClassName)) == null ? '' : __t) +
'">' +
((__t = (field)) == null ? '' : __t) +
'</td>\n                    ';
 var cellData = aData[field];
                       if (cellData === undefined) {
                          cellData = "undefined";
                       }
                       if (cellData.toLowerCase().indexOf('http://') === 0 || cellData.toLowerCase().indexOf('https://') === 0 ) {
                        cellData = "<a href=\""+cellData+"\" title=\""+cellData+"\" target=\"_blank\"><span class=\"DescartesUIText\">Lien</span></a>";
                       }
                    ;
__p += '\n                    <td class="' +
((__t = (textClassName)) == null ? '' : __t) +
'">' +
((__t = (cellData)) == null ? '' : __t) +
'</td>\n                </tr>\n                ';
});;
__p += '\n            </tbody>\n        </table>\n        ';
 if (result.data.length === 2) {;
__p += '\n        <div>\n            <label class="' +
((__t = (labelClassName)) == null ? '' : __t) +
'">... ' +
((__t = (result.data.length-1)) == null ? '' : __t) +
' autre objet superposé</label>\n        </div>\n        ';
} else if (result.data.length > 2) {;
__p += '\n         <div>\n            <label class="' +
((__t = (labelClassName)) == null ? '' : __t) +
'">... ' +
((__t = (result.data.length-1)) == null ? '' : __t) +
' autres objets superposés</label>\n        </div>       \n        ';
};
__p += '\n    </div>\n    ';
});;
__p += '\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/ToolTipContainer.ejs
// module id = 440
// module chunks = 0